export const BOOKING_URL =
  'https://eu.halaxy.com/profile/yh-physio-performance-by-yhaq-healthcare-ltd/location/448002';

export const INSTAGRAM_URL =
  'https://www.instagram.com/yh_physio_performance?igsh=bnBoMGUxeTEyZ3gy&utm_source=qr';

export const CLINIC_IMAGE = '/yh-physio-performance-bradford-clinic.png';
export const CLINIC_IMAGE_ALT =
  'Yasmin Haq physiotherapist at YH Physio & Performance in Bradford';

export const CONTACT_EMAIL = 'info@yhphysio.com';

export const GOOGLE_REVIEWS_URL =
  'https://www.google.com/search?kgmid=/g/11z0f2gywv&q=YH+Physio+and+Performance#lrd=0x487be59118a7042d:0x77472d4035aa8833,1,,,,';

/** Set to true when Formspree is configured and the contact form should be shown */
export const CONTACT_FORM_ENABLED = false;

/** Formspree form ID — sign up at https://formspree.io and set recipient to CONTACT_EMAIL */
const formspreeFormId = process.env.REACT_APP_FORMSPREE_FORM_ID?.trim() ?? '';
export const FORMSPREE_ENDPOINT = formspreeFormId
  ? `https://formspree.io/f/${formspreeFormId}`
  : '';
